module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7fe1b937b85dc7fdeded6837bea60a67.png";